// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import userInfoActions from '../../actions/userInfo';
import Introduction from './Introduction';
import {DEEP_LINK_PARAM_TYPE} from '../../utils/localStorageDataHandler';
import {isNetNewIPM, isUsSite} from '../../utils/validate';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        translations: state.app.translations,
        siteName: get(state, 'system.siteName', ''),
        firstName: get(state, 'userInfoDetails.userInfoMetadata.user.firstName', ''),
        userType: get(state, 'app.userType', 'IPM'),
        serviceError: get(state, 'userInfoDetails.errorKey', ''),
        enableLoadOverlay: get(state, 'app.enableLoadOverlay', false),
        pmscParams: get(state, 'app.pmscParams', {}),
        isSWSv2FlowEnabled: get(state, 'app.isSWSv2FlowEnabledFlag', ''),
        dyff: get(state, 'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class IntroductionContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.userInfoActions.getUserInfo();

        if (!this.props.isSWSv2FlowEnabled) {
            this.props.appActions.getAbacusExpFlag(['vrbo_qc_sws_v2_flow'], this.props.siteName);
        }
    }

    componentDidMount() {
        const {pmscParams} = this.props;
        const {advertiserAssignedId, currency, systemId, systemName} = pmscParams;

        if (advertiserAssignedId || systemId || currency) {
            this.props.appActions.saveDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams, {advertiserAssignedId, systemName, systemId, currency});
        }
    }

    handleSubmit(event) {
        const {userType, siteName} = this.props;

        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});

        if (this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
            if (isNetNewIPM(userType)) {
                this.props.appActions.changeAppState('SOFTWARE_DETAILS');
            } else {
                this.props.appActions.changeAppState('PROPERTY_COUNT');
            }
        } else {
            switch(userType) {
                case 'PPM' :
                        this.props.appActions.changeAppState('REVIEW_PAGE');
                    break;
                case 'IPM_SOFTWARE_SWITCH' :
                    if (!isUsSite(siteName)) {
                        this.props.appActions.changeAppState('REVIEW_PAGE');
                    } else {
                        this.props.appActions.changeAppState('SOFTWARE_DETAILS');
                    }
                    break;
                default:
                    this.props.appActions.changeAppState('SOFTWARE_DETAILS');
                    break;
            }
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Introduction');
    }

    handleAlertDismiss() {
        this.props.userInfoActions.alertError('');
    }

    render() {
        return (
            <Introduction
                publicUuid={this.props.publicUuid}
                serviceError={this.props.serviceError}
                handleSubmit={this.handleSubmit}
                translations={this.props.translations}
                handleAlertDismiss={this.handleAlertDismiss}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                siteName={this.props.siteName}
                userType={this.props.userType}
                firstName={this.props.firstName}
                disableContinueButton={this.props.enableLoadOverlay}
                isSWSv2FlowEnabled={this.props.isSWSv2FlowEnabled}
                showNewIntroContent={this.props.dyff?.SHARED_IPM_BANKING_ENABLED}
            />
        );
    }
}

IntroductionContainer.propTypes = {
    publicUuid: PropTypes.string,
    siteName: PropTypes.string,
    firstName: PropTypes.string,
    userType: PropTypes.string,
    translations: PropTypes.any // eslint-disable-line react/forbid-prop-types
};
